function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#1A1A1A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5 2.045c3.163 0 5.941 1.454 8.31 3.852a18.569 18.569 0 012.427 3.045l.253.411.138.239.217.408-.185.35-.17.297-.253.41a18.569 18.569 0 01-2.427 3.045c-2.369 2.399-5.147 3.853-8.31 3.853-3.163 0-5.941-1.454-8.31-3.852a18.569 18.569 0 01-2.427-3.045l-.253-.411-.138-.239L.155 10l.185-.35.17-.297.253-.41A18.569 18.569 0 013.19 5.897c2.369-2.399 5.147-3.853 8.31-3.853zm9.616 7.777a17.207 17.207 0 00-2.354-2.992C16.64 4.682 14.207 3.41 11.5 3.41S6.36 4.681 4.238 6.83A17.207 17.207 0 001.776 10a17.207 17.207 0 002.462 3.17c2.122 2.148 4.555 3.42 7.262 3.42s5.14-1.272 7.262-3.42a17.207 17.207 0 002.354-2.992l.108-.178-.108-.178z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 6.59c1.985 0 3.594 1.527 3.594 3.41 0 1.883-1.61 3.41-3.594 3.41-1.985 0-3.594-1.527-3.594-3.41 0-1.883 1.61-3.41 3.594-3.41zm0 1.365c-1.19 0-2.156.915-2.156 2.045s.965 2.045 2.156 2.045c1.19 0 2.156-.915 2.156-2.045s-.965-2.045-2.156-2.045z"
}));

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/eye.0183abbc.svg";
export { SvgEye as ReactComponent };